import React, { useState } from 'react';
import BoatGalleryModal from '../BoatsPage/BoatGalleryModal';
import MrSeaLogo from '../../../images/Logo/MrSea2025_logo_white.png';
import BoatEmptyImagePlaceholder from './BoatEmptyImagePlaceholder';

const THUMBNAIL_COUNT = 6;

const BoatPageGallery = ({ images = [] }) => {
  const [showModal, setShowModal] = useState(false);
  const [modalIndex, setModalIndex] = useState(0);

  const mainImage = images[0] || null;
  const rawThumbnails = images.slice(1, THUMBNAIL_COUNT + 1);
  
  const thumbnails = [
      ...rawThumbnails,
      ...Array(Math.max(0, THUMBNAIL_COUNT - rawThumbnails.length)).fill(null)
  ];

  return (
    <div className="boatpage-gallery-vertical">
      <div className="boatpage-gallery-vertical__main-wrapper" style={{ position: 'relative' }}>
        {mainImage ? (
            <img src={mainImage} alt="Main boat" className="boatpage-gallery-vertical__main-img" />
        ) : (
            <BoatEmptyImagePlaceholder />
        )}
        
        {images.length > 0 && (
            <>
                <img
                src={MrSeaLogo}
                alt="MR SEA Logo"
                className="boatpage-gallery-vertical__mrsea-logo"
                />
                <button
                className="boatpage-gallery-vertical__show-all"
                
                onClick={() => { setShowModal(true); setModalIndex(0); }}
                >
                View all photos
                </button>
            </>
        )}
      </div>
      <div className="boatpage-gallery-vertical__thumbnails">
        {thumbnails.map((img, idx) => (
          <div
            className={`boatpage-gallery-vertical__thumb-wrapper ${!img ? 'boatpage-gallery-vertical__thumb-wrapper--placeholder' : ''}`}
            key={idx}
            onClick={img ? () => { setShowModal(true); setModalIndex(idx + 1); } : undefined}
            style={{ cursor: img ? 'pointer' : 'default' }}
          >
            {img ? (
                <img src={img} alt={`Boat thumb ${idx + 2}`} className="boatpage-gallery-vertical__thumb-img" />
            ) : (
                <BoatEmptyImagePlaceholder />
            )}
          </div>
        ))}
      </div>
      {showModal && (
        <BoatGalleryModal
          images={images}
          currentIndex={modalIndex}
          onClose={() => setShowModal(false)}
          onChangeIndex={setModalIndex}
        />
      )}
    </div>
  );
};

export default BoatPageGallery; 